import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { AbstractComponent, NoResultComponent } from '@spike/scaffolds';
import { EtiquetteListComponent } from "../../../configuration/components/etiquette-list/etiquette-list";
import { EtiquetteStoreService } from '../../../configuration/services/etiquette-store.service';
import { OrganizationStoreService } from '../../services/organization-store.service';
import { Button } from "primeng/button";
import { InputText } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { OrganizationSidePanelComponent } from "../../panels/organization-side-panel/organization-side-panel";
import { BaseOrganizationEntity } from '../../models/organization-base-entity';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-organization-list',
  providers:[],
  imports: [EtiquetteListComponent, NoResultComponent, Button, InputText, FormsModule, OrganizationSidePanelComponent],
  templateUrl: './organization-list.html',
  styleUrl: 'organization-list.css'
})
export class OrganizationListComponent<T extends BaseOrganizationEntity> extends AbstractComponent{
  private readonly etiquetteStoreService = inject(EtiquetteStoreService);
  private readonly organizationStore = inject(OrganizationStoreService);

  entityKey = input.required<string >();
  entityApi = input.required<EntityApiEnum>();
  etiquetteApi = input.required<EtiquetteApiEnum>();
  modelApi = input.required<ModelApiEnum>();
  operationId = input<number|undefined>(undefined);

  // Internal state
  public filter = signal<any>({ stateId: 1, etiquetteId:null });
  public isSidepanelVisibile= signal<boolean>(false);
  public selectedItem = signal<number|undefined>(undefined);

  //resource
  public readonly entityList = this.organizationStore.getFilteredList<T>(this.entityApi, this.filter, this.operationId); 
  public readonly entityEtiquetteList = this.etiquetteStoreService.getReactiveList(this.etiquetteApi);

  
  //output
  onSelect = output<T>();
  onInsert = output<void>();
  
  
  public changeStateSearch(stateId: number): void {
    this.filter.update(f => ({ ...f, stateId }));
  }

  public onSearchByShortDesc(searchKey: string | null): void {
    this.filter.update(f => ({ ...f, shortDescription: searchKey }));
  }
  
  public searchByEtiquette(etiquetteId: number | null): void {
    this.filter.update(f => ({ ...f, etiquetteId }));
  }
  
  getId(entity: T): string {
     const val = (entity as any)[this.entityKey()]; 
     return String(val).padStart(4, '0');
  }

  selectDetailItem(item: T){
    this.selectedItem.set(item[this.entityKey()]);
    this.isSidepanelVisibile.set(true);
  }

  closeSidePanel(){
    this.isSidepanelVisibile.set(false);
    this.selectedItem.set(undefined);
  }

  onSave(){

  }

}